export default {"src":"/_next/static/media/conflictsManagement.ae122eaa.svg","height":400,"width":400,"blurWidth":0,"blurHeight":0};